import React from 'react';
import { Helmet } from 'react-helmet';
import SocialSharingImage from '../images/social-sharing.png';

// FYI, https://www.gatsbyjs.com/docs/add-seo-component/, suggest to use useStaticQuery but this caused issues in Jest and is not needed.
const seoDefaultValues = {
  defaultTitle:
    'Online-Tool zur Wirkungsschätzung von Fahrradabstellanlagen am Bahnhof',
  defaultDescription:
    'Mit diesem Wirkungsrechner können Sie mit wenig Aufwand unterschiedliche Wirkungen Ihrer am Bahnhof geplanten Fahrradabstellanlage abschätzen. Die Ergebnisse können zum Beispiel zur Kommunikation im kommunalpolitischen Kontext sowie mit Bürger:innen genutzt werden.',
  // todo ?
};

type Props = {
  title?: string;
  description?: string;
  noindex?: boolean;
};

export const HelmetSeo: React.VFC<Props> = ({
  title,
  description,
  noindex,
}) => {
  const { defaultTitle, defaultDescription } = seoDefaultValues;

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: SocialSharingImage,
    canonical: 'https://radparken.info/werkzeuge/wirkungsrechner',
  };

  if (noindex === true) {
    return (
      <Helmet>
        <title>{seo.title}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
    );
  }

  // FYI, we do not inlcude the url meta tags since there was an issue with specs and `useLocation`.
  //  Since we do not need this field, its OK to remove it.
  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta property="og:title" content={seo.title} />
      <meta name="twitter:title" content={seo.title} />

      <link rel="canonical" href={seo.canonical} />

      <meta name="description" content={seo.description} />
      <meta property="og:description" content={seo.description} />
      <meta name="twitter:description" content={seo.description} />

      <meta name="image" content={seo.image} />
      <meta property="og:image" content={seo.image} />
      <meta name="twitter:image" content={seo.image} />

      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};
